import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { X } from 'lucide-react';

const ScreenshotModal = ({ isOpen, onClose, agentId, agentName }) => {
  const screenshotUrl = `${process.env.REACT_APP_BACKEND_URL}/api/agent/${agentId}/screenshot?t=${Date.now()}`;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Screenshot - {agentName}</span>
            <button
              onClick={onClose}
              className="text-slate-500 hover:text-slate-700"
            >
              <X className="w-5 h-5" />
            </button>
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <img
            src={screenshotUrl}
            alt={`Screenshot of ${agentName}`}
            className="w-full h-auto rounded-lg border border-slate-200"
            onError={(e) => {
              e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="1280" height="720" viewBox="0 0 1280 720"%3E%3Crect fill="%23f1f5f9" width="1280" height="720"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="sans-serif" font-size="24" fill="%2394a3b8"%3ENo screenshot available%3C/text%3E%3C/svg%3E';
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ScreenshotModal;
